'use strict'
import _ from "lodash";
import ViewBase from '../view-base.view';
import photoModel from "../../models/photo/photo.model";
import ImageGridComponent from "../../components/image-grid/image-grid.component";
import UserBadgeComponent from '../../components/common/user-badge.component';
import { Dialog, Spinner } from "construct-ui";
import ImageCarouselComponent from "../../components/image-carousel/image-carousel.component";

export default function PhotoDetailsView() {
  ViewBase.call(this);

  let data;
  let imageList = [];
  let selectedImageId;
  let close = () => { };
  let isShowingCarousel = false;
  let isLoadingImages = false;

  let getAllImages = () => {
    isLoadingImages = true;
    imageList = [];

    photoModel.getAllImagesByPhotoId(data.photoIdString)
      .then((result) => {
        result.map(i => {
          imageList.push({
            id: i.fileMasterID,
            src: i.photoString,
          })
        });
      })
      .catch((error) => {
        console.error('imageList Error', error, JSON.parse(JSON.stringify(error)));
        this.handleError(error);
      })
      .finally(() => {
        isLoadingImages = false;
      });
  }

  return {
    oninit: (vnode) => {
      data = vnode.attrs.data;

      if (vnode.attrs.close) {
        close = vnode.attrs.close;
      }

      if (data?.photoIdString && data?.photoIdString.length > 0) {
        getAllImages();
      }
    },
    view: (vnode) => {
      return [
        m('.d-block.mb-1',
        m('.w-100',
          m('h2',
            m('i.bi.bi-arrow-left.cursor-pointer', {
              onclick: close
            }),
           this.getText("LT00000560", "Photo Details")
          )
        ),
        ),
        m('.photo-item.card',
          m('.card-body',
            m('.photo-item-sections',
              m('.photo-item-sections__left',
                // User Info Section
                m('.photo-item-user-info',
                  m(UserBadgeComponent, {
                    image: data.promoterPhotoString,
                    imageSize: '48px',
                  }, [
                    m('.user-name', { title: data.promoterName }, data.promoterName),
                  ]),
                ),
                // Main Section
                m('.photo-item-main',
                  m('.photo-item-main__info.line-clamping__multi-2',
                    { title: data.siteName },
                    m('.photo-item-main__info-title', this.getText("LT00000XXX", "Site") + ': '),
                    `[${data.siteId}] ${data.siteName}`
                  ),
                  m('.photo-item-main__info.line-clamping__multi-2',
                    { title: data.customerName },
                    m('.photo-item-main__info-title', this.getText("LT00000XXX", "Customer") + ': '),
                    data.customerName
                  ),
                  m('.photo-item-main__info.line-clamping__multi-3',
                    { title: data.location },
                    m('.photo-item-main__info-title', this.getText("LT00000XXX", "Location") + ': '),
                    data.location
                  ),
                ),
                // Secondary Section
                m('.photo-item-secondary',
                  m('.photo-item-secondary__info.line-clamping__single', { title: data.pictureType }, m('.photo-item-secondary__info-title', this.getText("LT00000XXX", "Picture Type") + ': '), data.pictureType),
                  m('.photo-item-secondary__info.line-clamping__single', { title: data.product }, m('.photo-item-secondary__info-title', this.getText("LT00000XXX", "Product") + ': '), data.product),
                  m('.photo-item-secondary__info.line-clamping__multi-2', { title: data.description }, m('.photo-item-secondary__info-title', this.getText("LT00000XXX", "Description") + ': '), data.description),
                  m('.photo-item-secondary__info.line-clamping__single', { title: data.surveyDate }, m('.photo-item-secondary__info-title', this.getText("LT00000XXX", "Date") + ': '), data.surveyDate),
                ),
              ),
            ),
            m('hr.my-3'),
            isLoadingImages
              ? m('.position-relative.py-5',
                m(Spinner, {
                  active: isLoadingImages,
                  fill: true,
                  size: 'xl',
                })
              )
              : m(ImageGridComponent, {
                imageList: imageList,
                onImageClick: (imgId) => {
                  selectedImageId = imgId;
                  isShowingCarousel = true;
                }
              })
          )
        ),
        m(Dialog, {
          isOpen: isShowingCarousel,
          closeOnOutsideClick: false,
          onClose: () => { isShowingCarousel = false; },
          title: this.getText("LT00000460", "Gallery"),
          content: m(ImageCarouselComponent, {
            onPopupClose: () => {
              isShowingCarousel = false;
              selectedImageId = undefined;
            },
            files: imageList,
            selectedFileId: selectedImageId
          }),
          "class": "cui-dialog-xxl"
        }),
        this.getBaseViews()
      ]
    },
  };
}
